import React, {useEffect, useState} from "react";
import axios from 'axios';

const baseUrl = 'https://membershipapi.kenes.com/';
// const baseUrl = 'https://84.110.107.18:5001/';


export const GET = url => {
    return axios.get(`${baseUrl}/${url}`);
}

const headers = {};
// const headers = {
//     'Accept': 'application/json',
//         // 'Content-Type': 'application/json'
// };
// const headers = { 'Content-Type': 'application/json' }


const checkMemberFunc = (actionName, data, successCallback, failCallback) => {


    /*  let formData = new FormData();
      formData.append('token', data.token);
      axios({
          url: `${baseUrl}api/values/${actionName}`,
          method: 'post',
          headers: {
              'Content-Type': 'multipart/form-data'
          },
          data: formData
      }).then((result) => {
          debugger;
          /!*this.$message({
              message: 'Request success',
              type: 'success',
              showClose: true
          });*!/
      }).catch((err) => {
          debugger;
          /!*this.$message({
              message: 'Request failed',
              type: 'error',
              showClose: true
          });*!/
      })*/

    /*
        fetch(`${baseUrl}api/values/${actionName}`, {mode: 'cors'})
            .then(response => response.clone().json())
            .then(jsonBody => { console.log(jsonBody); return jsonBody; })
            .then(result => console.log(result));
    */

    return axios
        .post(`${baseUrl}api/values/${actionName}`, data)
        .then(response => {
            successCallback(response);
        })
        .catch(function (error) {
            failCallback(error);
            console.log(error);
        });
    debugger;

    /*
        return fetch(`${baseUrl}api/values/${actionName}`, {
            mode: 'cors',
            method: 'POST',
            headers: {
                // 'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then((item) => {
                debugger;
                successCallback(item);
            })
            .catch((error) => {
                debugger;
                failCallback(error);
            });
    */


}

export const CheckMember = (actionName, data, successCallback, failCallback) => {

    if (typeof grecaptcha !== 'undefined') {
        window.grecaptcha.ready(function () {
            window.grecaptcha.execute('6Lc4pIUUAAAAAG-r76A6RhcMTiI4Bh0JKi1Mv7qW', {action: 'submit'})
            // window.grecaptcha.enterprise.execute('6Lc4pIUUAAAAAG-r76A6RhcMTiI4Bh0JKi1Mv7qW', {action: 'submit'})
                .then(function (token) {
                    debugger;
                    if (data == null) {
                        data = {};
                    }
                    data['token'] = token;
                    checkMemberFunc(actionName, data, successCallback, failCallback);
                });
        });
    }
}
